import { request } from "../services/Request";
import { routes } from "../constants/constant.route";
import { urlConstants } from "../utils/urlConstants";

const { API_URL } = urlConstants;
const {
  GET_UNREAD_MESSAGE_COUNT,
  GET_MESSGAE_LIST_PER_USER,
  SEND_MESSAGE,
  PARENT_GET_UNREAD_MESSAGE_COUNT,
  PARENT_GET_MESSAGES_PER_USER,
  READ_COUNT_DATE,
  VERIFY_NUDGE,
  SEND_OTP,
  RESEND_OTP,
  VERIFY_OTP,
  TWILIO_COST_ESTIMATION,
  APPROVALS,
  STATUS_UPDATE,
  GET_COLLEGE_LIST,
  GET_DISTRICT_LIST,
  GET_REQUESTER_LIST,
} = routes.MESSAGE;

export default class MsgDataService {
  static getMsgData(page) {
    return request("GET", `${API_URL}${routes.msg.GET_TOTAL_MESSAGE_LIST}?page=${page}`, null, null, null);
  }

  static getMsgRecruiterData(page, type) {
    return request("GET", `${API_URL}${routes.msg.GET_TOTAL_MESSAGE_LIST}?page=${page}&event_type=${type}`, null, null, null);
  }

  static getTotalMessageList() {
    return request('GET', `${API_URL}${routes.msg.GET_TOTAL_MESSAGE_LIST}`, null, null, null)
  }

  static getTotalParentCount() {
    return request('GET', `${API_URL}${routes.msg.GET_PARENT_COUNT}`, null, null, null)
  }

  static getCounselorNotificationCount() {
    return request('GET', `${API_URL}/api/counsellor/message_notification/`, null, null, null)
  }

  static getParentMessageList(child_id) {
    return request('GET', `${API_URL}${routes.msg.GET_TOTAL_MESSAGE_LIST}?child_id=${child_id}`, null, null, null)
  }

  static getCannedMsg(obj) {
    return request('GET', `${API_URL}${routes.getCannedMsg.GET_CANNED_MSG}?school_id=${obj.school_id}&page=${obj.page}`, null, null, null)
  }

  static getList(isStudentOrCounselor, queryValue) {
    let query;
    if (queryValue.length > 0) {
      if (isStudentOrCounselor === 'students') {
        query = 'q'
      } else {
        query = 'q'
      }
    }
    return request('GET', `${API_URL}${routes.getListOfStudent.GET_LIST}?role=${isStudentOrCounselor}&${query}=${queryValue}`, null, null, null)


  }
  static sendMessage(body) {
    return request('POST', `${API_URL}${routes.sendMessage.SEND_MESSAGE}`, null, body, null)
  }

  static attachment(body) {
    return request('POST', `${API_URL}${routes.attachment.ATTACHMENT}`, null, body, null, null, "formData-single-attachment", "message_file")
  }

  static deleteattachment(body) {
    return request('DELETE', `${API_URL}${routes.attachment.ATTACHMENT}`, null, body, null, null, null)
  }

  static deleteRecruiterMsg(body) {
    return request('DELETE', `${API_URL}${routes.deleteMessage.DELETE_REC_MESSAGE}`, null, body, null, null, null)
  }

  static deleteMsg(body) {
    return request('DELETE', `${API_URL}${routes.deleteMessage.DELETE_MESSAGE}`, null, body, null, null, null)
  }

  static deleteGroupMsg(body) {
    return request('DELETE', `${API_URL}${routes.deleteMessage.DELETE_GROUP_MESSAGE}?message_id=${body.message_id}`, null, null, null, null, null)
  }

  static deleteScheduleMsg(body) {
    return request('DELETE', `${API_URL}${routes.deleteMessage.DELETE_SCHEDULE_MESSAGE}?message_id=${body.message_id}`, null, null, null, null, null)
  }

  static getScheduleMessage(messageId) {
    return request('GET', `${API_URL}${routes.counselor.get_schdule_messages}?message_id=${messageId}`, null, null, null, null, null);
  }
  
  static updateScheduleMessage(data) {
    return request('PUT', `${API_URL}${routes.counselor.get_schdule_messages}`, null, data, null, null, null);
  }

  static getCannedMsgPage(role, id, page) {
    const queryParam = role === 'recruiter' ? 'college_id' : 'school_id';
    const url = `${API_URL}${routes.getMessageTemplate.getMessageTemplate}?${queryParam}=${id}&page=${page}`;

    return request('GET', url, null, null, null, null, null);
  }

  static getSection() {
    const url = `${API_URL}${routes.getMessageTemplate.getSection}`;
    return request('GET', url, null, null, null, null, null);
  }

  static getCannedNudgeMsgPage(id, section, page) {
    const url = `${API_URL}${routes.getMessageTemplate.getMessageNudgeTemplate}?school_id=${id}&section=${section}&page=${page}`;
    return request('GET', url, null, null, null, null, null);
  }

  static deleteCannedMessageTemplate(body) {
    return request('DELETE', `${API_URL}${routes.deleteMessageTemplate.deleteMessageTemplate}`, null, body, null, null, null)
  }

  static getSingleMessagesForStudent = (id) => {
    return request('GET', `${API_URL}${routes.getSingleMessageForStudent.getSingleMessageForStudent}/${id}`, null, null, null, null);
  }

  static getIdOfSelectedRole = (body) => {
    return request('POST', `${API_URL}${routes.getSingleMessageForStudent.gettingIdForMessageList}`, null, body, null, null, null)
  }

  static query_result_message = (body) => {
    return request('POST', `${API_URL}${routes.query_result_pagination.query_result_pagination}`, null, body, null, null, null)
  }

  static verifyNudge(body) {
    return request('POST', `${API_URL}${VERIFY_NUDGE}`, null, body, null, null, null);
  }

  static sendOtp() {
    return request('GET', `${API_URL}${SEND_OTP}`, null, null, null, null, null);
  }

  static resendOtp() {
    return request('GET', `${API_URL}${RESEND_OTP}`, null, null, null, null, null);
  }

  static verifyOtp(body) {
    return request('POST', `${API_URL}${VERIFY_OTP}`, null, body, null, null, null);
  }

  static twilioMessageCostEstimation(body) {
    return request('POST', `${API_URL}${TWILIO_COST_ESTIMATION}`, null, body, null, null, null);
  }

  static buildApprovalPayload(basePayload, verifyNudgeResponse) {
    const verifyData = verifyNudgeResponse?.data || verifyNudgeResponse || {};
    return {
      ...basePayload,
      receiver_student_count: verifyData.receiver_student_count ?? 0,
      receiver_parent_count: verifyData.receiver_parent_count ?? 0,
      groups: verifyData.groups ?? [],
    };
  }

  static submitMessageApproval(body, previousEndpoint) {
    console.log("[Message Approval] Previous endpoint:", previousEndpoint);
    console.log("[Message Approval] New endpoint:", APPROVALS);
    console.log("[Message Approval] Payload:", body);
    return request('POST', `${API_URL}${APPROVALS}`, null, body, null, null, null);
  }

  static getMessageApprovals(page = 1, q = '', filters = {}) {
    const normalizeStatusFilter = (value) => {
      if (!value) return '';
      const normalized = String(value).trim().toLowerCase();
      return normalized === 'declined' ? 'decline' : String(value).trim();
    };

    const params = new URLSearchParams();
    params.append('page', String(page));
    if (q) params.append('q', q);
    if (filters.role) params.append('role', filters.role);
    if (filters.userId) params.append('user_id', filters.userId);
    else if (filters.userName) params.append('user_name', filters.userName);
    if (filters.districtId) params.append('district_id', filters.districtId);
    if (filters.collegeId) params.append('college_id', filters.collegeId);
    if (filters.adminAction) {
      params.append('admin_action', normalizeStatusFilter(filters.adminAction));
    }
    if (filters.requestStatus) {
      params.append('request_status', normalizeStatusFilter(filters.requestStatus));
    }
    if (filters.status) params.append('status', filters.status);
    if (filters.fromDate) params.append('from_date', filters.fromDate);
    if (filters.toDate) params.append('to_date', filters.toDate);
    return request('GET', `${API_URL}${APPROVALS}?${params.toString()}`, null, null, null, null, null);
  }

  static getApprovalCollegeList(q = '') {
    return request(
      'GET',
      `${API_URL}${GET_COLLEGE_LIST}?q=${encodeURIComponent(q)}`,
      null,
      null,
      null,
      null,
      null
    );
  }

  static getApprovalDistrictList(q = '') {
    return request(
      'GET',
      `${API_URL}${GET_DISTRICT_LIST}?q=${encodeURIComponent(q)}`,
      null,
      null,
      null,
      null,
      null
    );
  }

  static getApprovalRequesterList(q = '') {
    return request(
      'GET',
      `${API_URL}${GET_REQUESTER_LIST}?q=${encodeURIComponent(q)}`,
      null,
      null,
      null,
      null,
      null
    );
  }

  static deleteMessageApproval(id) {
    return request('DELETE', `${API_URL}${APPROVALS}${id}/`, null, null, null, null, null);
  }

  static getMessageApprovalById(id) {
    return request('GET', `${API_URL}${APPROVALS}${id}/`, null, null, null, null, null);
  }

  static updateMessageApprovalStatus(id, requestStatus) {
    return request(
      'PUT',
      `${API_URL}${APPROVALS}${id}/`,
      null,
      { request_status: requestStatus },
      null,
      null,
      null
    );
  }

  static updateApprovalSendStatus(id) {
    return request(
      'POST',
      `${API_URL}${STATUS_UPDATE}`,
      null,
      { id },
      null,
      null,
      null
    );
  }

  //student
  static getUnreadCountForStudent = () => {
    return request(
      "GET",
      `${API_URL}${GET_UNREAD_MESSAGE_COUNT}`,
      null,
      null,
      null,
      null,
      null
    );
  };

  //parent
  static getUnreadCountForParent = (id) => {
    return request(
      "GET",
      `${API_URL}${PARENT_GET_UNREAD_MESSAGE_COUNT}?child_id=${id}`,
      null,
      null,
      null,
      null,
      null
    );
  };

  //student msg
  static getMessageListPerUser = (page, src_id) => {
    return request(
      "GET",
      `${API_URL}${GET_MESSGAE_LIST_PER_USER}?page=${page}&src_id=${src_id}`,
      null,
      null,
      null,
      null,
      null
    );
  };

  //parent msg - conversation thread by child_id only (recruiter parent tab)
  static getParentReceivedMessages = (page, child_id) => {
    return request(
      "GET",
      `${API_URL}${GET_MESSGAE_LIST_PER_USER}?page=${page}&child_id=${child_id}`,
      null,
      null,
      null,
      null,
      null
    );
  };

  //parent msg - legacy: src_id + child_id
  static getMessageParentListPerUser = (page, src_id, student_id) => {
    return request(
      "GET",
      `${API_URL}${GET_MESSGAE_LIST_PER_USER}?page=${page}&src_id=${src_id}&child_id=${student_id}`,
      null,
      null,
      null,
      null,
      null
    );
  };

  //timezone
  static getTimezoneList = (query) => {
    return request('GET', `${API_URL}${routes.getTimezone.getTimezoneList}?q=${query}`, null, null, null, null, null);
  }

  // send Message
  static reply = (body) => {
    return request('POST', `${API_URL}${SEND_MESSAGE}`, null, body, null, null, null)
  }

  static getSpecificMessageDetail = (id) => {
    return request('GET', `${API_URL}${SEND_MESSAGE}/${id}`, null, null, null, null, null)
  }

  static readCountDate = (body) => {
    return request('POST', `${API_URL}${READ_COUNT_DATE}`, null, body, null, null, null)
  }

  // Mark counselor messages as read for a conversation (by src_id)
  static counselorReadMessage = (body) => {
    // body shape: { src_id: string|number }
    return request('POST', `${API_URL}/api/counsellor/read_message/`, null, body, null, null, null);
  }

  // Parent
  static getParentRoleTotalUnreadCount(queryValue) {
    let { user_id, school_id } = queryValue;
    let qString = `?user_id=${user_id}&school_id=${school_id}`
    return request("GET", `${API_URL}${PARENT_GET_UNREAD_MESSAGE_COUNT}`, null, null, null, null);
  }

  static getParentRoleMessagePerUser(queryValue) {
    let { student_id, massenger_id } = queryValue;
    let qString = `?student_id=${student_id}&massenger_id=${massenger_id}`
    return request("GET", `${API_URL}${PARENT_GET_MESSAGES_PER_USER}${qString}`, null, null, null, null);
  }

}